import React from "react";
import {
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
  Text,
  Image,
  TouchableOpacity,
  ImageBackground,
} from "react-native";
import { fonts } from "../common/styles/fonts";
import { colors } from "../common/styles/colors";
import { CommonButton } from "./buttons";
import { ReactComponent as PinLightYellowIcon } from "../common/svg/map_light.svg";
import { getPlaceTags, TagsWithDivider } from "./PlaceCard";
import { FullPlaceType } from "../api/custom-models/place";

export function PlaceCardMessage({
  place,
  containerStyles,
  onPress,
}: {
  place: FullPlaceType;
  containerStyles?: StyleProp<ViewStyle>;
  onPress?: () => void;
}) {
  return (
    <TouchableOpacity
      key={place.place_id}
      onPress={onPress}
      style={[styles.card, containerStyles]}
    >
      <ImageBackground
        source={{ uri: place.picture_1 }}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          zIndex: -1,
        }}
      >
        <View
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#000",
            opacity: 0.3,
          }}
        />
      </ImageBackground>

      <View style={{ padding: 12, flex: 1 }}>
        <Text style={styles.name}>{place.name}</Text>
        <CommonButton
          type="white"
          title={place.address}
          style={{
            alignSelf: "flex-start",
            maxWidth: "100%",
          }}
          containerStyle={styles.locationContainer}
          textStyle={{
            ...fonts.smallText_bold,
            paddingLeft: 24,
          }}
          LeftIcon={
            <PinLightYellowIcon
              style={{ left: 8, top: 9, position: "absolute" }}
            />
          }
        />
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: "auto",
          }}
        >
          <TagsWithDivider tags={getPlaceTags(place)} />
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  card: {
    overflow: "hidden",
    width: 280,
    height: 280,
    borderRadius: 12,
    backgroundColor: colors.black,
  },
  name: {
    ...fonts.mediumText_bold,
    color: colors.white,
    marginBottom: 8,
  },
  locationContainer: {
    paddingVertical: 8,
    position: "relative",
    paddingLeft: 0,
    paddingRight: 12,

    maxWidth: "100%",
  },
  point: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: colors.white,
    marginHorizontal: 8,
  },
});
